export default __webpack_public_path__ + "assets/article.18d44826.svg";